import { render, staticRenderFns } from "./rectangleStyle.vue?vue&type=template&id=4cd0dc0d&"
import script from "./rectangleStyle.vue?vue&type=script&lang=ts&"
export * from "./rectangleStyle.vue?vue&type=script&lang=ts&"
import style0 from "./rectangleStyle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports